import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @description
 */
import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import { ProDescriptions } from '@ant-design/pro-components';
//工具
import classNames from 'classnames';
import { values } from 'lodash-es';
import dayjs from 'dayjs';
import { dictQueryCode } from '@core/service-api';
import { FilePreviewItem } from '../FilePreview';
const Nzh = require('nzh').cn;
//css
import styled from './index.module.less';
import { ImageVideoGroup } from './ImageVideoGroup';
// 图片视频
export const renderImageHtml = (fileData, itemKey, cfg) => {
    const { emptyText = '--', ...imageProps } = cfg ?? {};
    let htmlObj = undefined;
    if (!fileData) {
        return htmlObj ?? emptyText;
    }
    let newFileData = [];
    if (Array.isArray(fileData)) {
        newFileData = fileData;
    }
    else {
        newFileData.push(fileData);
    }
    if (newFileData.length === 0) {
        return emptyText;
    }
    htmlObj = (_jsx("div", { children: _jsx(ImageVideoGroup, { fileList: newFileData, ...imageProps }, itemKey) }, itemKey));
    return htmlObj ?? emptyText;
};
export const renderFileHtml = (fileData, emptyText = '--', fieldProps) => {
    let htmlObj;
    if (!fileData) {
        return emptyText;
    }
    let newFileData = [];
    if (Array.isArray(fileData)) {
        newFileData = fileData;
    }
    else {
        newFileData.push(fileData);
    }
    if (newFileData.length === 0) {
        return emptyText;
    }
    htmlObj = newFileData.map((file) => {
        const fileArr = file?.fileName?.split('.');
        const fileType = fileArr.length > 1 ? fileArr[fileArr.length - 1] : undefined;
        return (_jsx("div", { className: styled.imageItem, children: _jsx(FilePreviewItem, { fileName: file.fileName, fileSrcUrl: file?.fileSrcUrl, bucket: file.bucket, objectName: file.objectName, isActive: fileType
                    ? ['png', 'jpg', 'pdf', 'jpeg', 'mp4', 'gif'].includes(fileType.toLocaleLowerCase())
                    : fileType, ...(fieldProps ?? {}) }, file.id) }));
    });
    return htmlObj || emptyText;
};
const toThousandFilterZero = (_num) => {
    if (Number(_num) == 0 || !_num) {
        return undefined;
    }
    return _num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
const digitUppercase = (_num) => {
    if (Number(_num) == 0 || !_num) {
        return undefined;
    }
    return Nzh.toMoney(_num).replace('人民币', '(人民币)');
};
const getDesRowKey = (item, isString) => {
    let itemKey = item.dataIndex;
    if (itemKey) {
        if (Array.isArray(itemKey)) {
            itemKey = itemKey;
        }
        else {
            itemKey = [itemKey];
        }
    }
    else if (item.key) {
        itemKey = [item.key];
    }
    if (isString) {
        return itemKey.join(',');
    }
    return itemKey;
};
const getDictRender = (config, row) => {
    // 用 == ，后端有时候类型返回的不对
    const dictValue = config?.options?.find?.(item => item.code == config.value)?.name;
    if (config?.format) {
        return config.format(row, dictValue, { dictOptions: config?.options ?? [] }) || config.emptyText;
    }
    else {
        return dictValue ?? config.emptyText;
    }
};
export const BaseDetailInfo = (props) => {
    const { rowInfo, infoConfig, theme = 'light', emptyText = '--', dictCodeRequest, downloadRequest, cardProps, } = props;
    const [dictObj, setDictObj] = useState({});
    const momentDate = (date, format) => {
        if (date && date != 0) {
            return dayjs(Number(date)).format(format || 'YYYY-MM-DD');
        }
        else {
            return emptyText;
        }
    };
    useEffect(() => {
        let codes = [];
        const curDictCodes = infoConfig?.dictCodes || {};
        if (infoConfig?.dictCodes) {
            codes = values(curDictCodes);
        }
        if (infoConfig.data?.length > 0) {
            infoConfig.data.forEach(item => {
                if (item.type === 'dict' && item.dictCode) {
                    const itemKey = getDesRowKey(item, true);
                    curDictCodes[itemKey] = item.dictCode;
                    if (!codes.includes(item.dictCode)) {
                        codes.push(item.dictCode);
                    }
                }
            });
        }
        if (codes?.length > 0) {
            const req = dictCodeRequest ?? dictQueryCode;
            req(codes.length === 1
                ? codes[0]
                : {
                    types: codes,
                }).then((resData) => {
                const keys = Object.keys(curDictCodes);
                const newDictObj = {};
                keys.forEach((key) => {
                    if (keys.length === 1) {
                        newDictObj[key] = resData;
                    }
                    else {
                        newDictObj[key] = resData[curDictCodes[key]];
                    }
                });
                setDictObj(newDictObj);
            });
        }
    }, []);
    return (_jsxs(Card, { className: `base-detail-info-card ${classNames(styled.baseDetailInfoCard, {
            [styled.noPadding]: !props.title,
        })} ${styled[`baseDetailInfo_${theme}`]}`, style: { position: 'relative' }, title: props.title, bordered: false, extra: props.extra, ...cardProps, children: [props.above, _jsx(ProDescriptions, { column: {
                    xs: 1,
                    sm: 1,
                    md: 2
                }, ...props.extend, children: infoConfig.data &&
                    infoConfig.data.map((item, index) => {
                        const itemKey = getDesRowKey(item);
                        let itemVal = rowInfo;
                        itemKey.forEach(element => {
                            if (itemVal) {
                                itemVal = itemVal[element];
                            }
                        });
                        if (itemVal === 0) {
                            itemVal = '0';
                        }
                        return (_jsx(React.Fragment, { children: 
                            /* visible 方法控制 字段的显示与隐藏 */
                            (typeof item.visible === 'function'
                                ? item.visible(rowInfo)
                                : !item.visible) && (_jsx(ProDescriptions.Item, { label: item.labelFormat
                                    ? item.labelFormat(rowInfo)
                                    : item.label, ...item?.extend, ...item?.itemProps, children: item.type == 'date' /*时间*/ ? (momentDate(Number(itemVal), item.formatter)) : item.type == 'file' /*文件渲染*/ ? (_jsx("div", { children: renderFileHtml(itemVal, emptyText) })) : item.type == 'image' /*图片视频渲染*/ ? (_jsx("div", { children: renderImageHtml(itemVal, itemKey.join(','), { fieldNames: item.imageFieldNames, emptyText }) })) : item.type == 'dict' ? (getDictRender({
                                    ...item,
                                    emptyText,
                                    options: dictObj?.[itemKey.join(',')],
                                    value: itemVal
                                }, rowInfo)) : item.type == 'money' ? (_jsxs("div", { children: ["\u00A5", toThousandFilterZero(itemVal) || 0, ' ', _jsx("div", { style: {
                                                display: 'inline-block',
                                                ...item.digitStyle,
                                            }, children: digitUppercase(itemVal || 0) })] })) : item.type == 'html' ? (_jsx("div", { style: { whiteSpace: 'pre-wrap' }, dangerouslySetInnerHTML: {
                                        __html: itemVal || emptyText,
                                    } })) : item.format ? (item.format(props.rowInfo) || emptyText) : item.type === 'slot' /* 兼容旧的， 使用上面的format */ ? (item.slot?.(rowInfo)) : (itemVal || emptyText) })) }, index));
                    }) })] }));
};
